import { jsx as t, jsxs as p, Fragment as E } from "react/jsx-runtime";
import { forwardRef as H, useState as O } from "react";
import { useMultiStyleConfig as W, Flex as k, Box as T, Divider as q } from "@chakra-ui/react";
import { FormControl as z } from "../../FormControl/FormControl.mjs";
import { SelectBase as L } from "../../Select/SelectBase.mjs";
import P from "./TimeMask.mjs";
import { convertDateToTimeInput as A, isTimeStringValid as x, convertTimeInputToDateString as C } from "./timeInputFunctions.mjs";
const G = H((I, S) => {
  const {
    name: o,
    controlStyleProps: F,
    controlClassName: b,
    "data-testid": r,
    error: y,
    formHelperText: w,
    hideOptionalLabel: D = !1,
    id: c = o,
    is24Hour: a = !1,
    isDisabled: M,
    isReadOnly: m,
    isRequired: N,
    label: _,
    onChange: s,
    placeholder: $,
    size: f = "md",
    value: h,
    variant: u = "outline",
    ...R
  } = I, [e, v] = O(
    h ? A(h, a) : {
      timeField: "",
      meridiem: "am"
    }
  ), g = W("DualInput"), V = (l, n) => {
    if (n.event) {
      const { event: i } = n;
      i.currentTarget.value = l.formattedValue;
      const d = i.currentTarget.value;
      if (v({ ...e, timeField: d }), d && x(d, a)) {
        const B = C(d, e.meridiem, a);
        s(B, i);
      } else
        s(null, i);
    }
  }, j = (l) => {
    const n = l.target.value;
    if (v({ ...e, meridiem: n }), x(e.timeField)) {
      const i = C(e.timeField, n);
      s(i, l);
    } else
      s(null, l);
  };
  return /* @__PURE__ */ t(
    z,
    {
      name: o,
      hideOptionalLabel: D,
      id: c,
      error: y,
      label: _,
      isDisabled: M,
      isReadOnly: m,
      isRequired: N,
      formHelperText: w,
      "data-testid": r && `${r}-control`,
      className: b,
      ...F,
      children: /* @__PURE__ */ p(k, { direction: "row", wrap: "nowrap", children: [
        /* @__PURE__ */ t(T, { __css: { ...!a && g.leftElement }, flex: "1", children: /* @__PURE__ */ t(
          P,
          {
            ref: S,
            name: o,
            id: c,
            className: "dual-input-left",
            "data-testid": r,
            placeholder: $,
            timeInfo: e,
            onChange: V,
            variant: m ? "filled" : u,
            size: f,
            ...R
          }
        ) }),
        !a && /* @__PURE__ */ p(E, { children: [
          (m || u === "filled") && /* @__PURE__ */ t(
            q,
            {
              orientation: "vertical",
              color: "gray.200",
              height: "auto",
              border: "0px solid",
              borderWidth: "0 0 0 1px"
            }
          ),
          /* @__PURE__ */ t(T, { __css: g.rightElement, maxW: "50%", children: /* @__PURE__ */ p(
            L,
            {
              name: `${o}-select`,
              id: `${c}-select`,
              className: "dual-input-right",
              "data-testid": r ? `${r}-select` : void 0,
              value: e.meridiem,
              onChange: j,
              variant: m ? "filled" : u,
              size: f,
              "aria-label": "Meridiem select",
              children: [
                /* @__PURE__ */ t("option", { value: "am", children: "a.m." }),
                /* @__PURE__ */ t("option", { value: "pm", children: "p.m." })
              ]
            }
          ) })
        ] })
      ] })
    }
  );
});
G.displayName = "TimeInput";
export {
  G as TimeInput
};
